// @flow
import TVGConf from "@tvg/conf";

export const tvgHeaders = (): {
  [key: string]: string
} => ({
  "content-type": "application/json",
  "x-tvg-context": TVGConf().context(),
  "x-requested-with": "XMLHttpRequest" // we need this some the request works on old request
});

export default tvgHeaders;
